import MirsTable from "components/general/table/Table";
import Competitors from "components/presentation/Competitor"
import Noc from "components/presentation/Noc";
import { ResultCompetitor } from 'components/presentation/ResultRank'
import { useMemo } from "react";
import CaptionTable from "components/general/table/CaptionTable";
import Label from "components/general/Label"
import { getIsIndividual, getIsMixed } from 'components/sports/tri/helper/TriHelpers'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TriRaceFacts = ({ data, numRows }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const isIndividual = getIsIndividual(mirs_rsc);
    const isMixed = getIsMixed(mirs_rsc)
    let actions =[];
    let actions2 = [];

    if (numRows) {
        actions = data?.results?.playByPlay && data?.results?.playByPlay[0].actions?.sort((a, b) => b.pbpa_order - a.pbpa_order).slice(0, numRows)
    } else {
        data?.results?.playByPlay?.forEach(play => {
            actions.push(...play?.actions)
        });
        actions?.sort((a, b) => a.pbpa_order - b.pbpa_order);
    }
    const resultsItems = data?.results?.items


    function getLegColumn() {
        if (isMixed) {
            return (
                [{
                    id: "id2",
                    Header: "Leg",
                    accessor: "extendedActions[0].pbpea_value",
                }]
            )
        } else {
            return []
        }
    }

    const tableColumns =
        [
            {
                id: "id1",
                Header: "Segment",
                accessor: 'pbpa_period',
            },
            ...getLegColumn(),
            {
                id: "id3",
                Header: "Lap",
                accessor: 'pbpa_When',
            },
            {
                id: "id4",
                Header: "Fact",
                headerClassName: "text-start",
                accessor: 'pbpa_ActionDesc',
                className: "text-start text-wrap "
            },
            {
                id: "id5",
                Header: isIndividual ? "Athletes involved" : "Teams / Athletes involved",
                headerClassName: "text-start w-40",
                accessor: 'pbpa_order',
                className: "text-start",
                Cell: (props) => {

                    const competitors = props.cell.row.original?.competitors?.map((competitor, key) =>
                        competitor.athletes.map((athlete, key) => {

                            let component
                            if (isIndividual) {
                                let athleteItem = resultsItems?.find(item => item.participant?.code === athlete?.pbpat_code)
                                component = <ResultCompetitor
                                    key={`Athlete-Involved-${key}`}
                                    bib={athleteItem?.bib}
                                    noc={<Noc code={athleteItem?.participant?.organisation?.code} />}
                                    competitor={<Competitors
                                        name={athleteItem?.participant?.name}
                                        shortName={athleteItem?.participant?.shortName}
                                        hidePicture={true}
                                        noc={athleteItem?.participant?.organisation?.code}
                                        code={athleteItem?.participant?.code}
                                    />} />
                            } else {
                                let athleteItem
                                resultsItems?.map((team, key) => {
                                    let value = team?.teamAthletes?.find(item => item?.athlete?.code === athlete?.pbpat_code)
                                    if (value) {
                                        athleteItem = value;
                                    }
                                    return
                                }
                                )
                                component = <ResultCompetitor
                                    key={`Athlete-Involved-${key}`}
                                    bib={athleteItem?.bib}
                                    noc={<Noc code={athleteItem?.athlete?.organisation?.code} />}
                                    competitor={<Competitors
                                        name={athleteItem?.athlete?.name}
                                        shortName={athleteItem?.athlete?.shortName}
                                        hidePicture={true}
                                        noc={athleteItem?.athlete?.organisation?.code}
                                        code={athleteItem?.athlete?.code}
                                    />} />
                            }
                            return (
                                component
                            )
                        }
                        )
                    );
                    return (
                        <>
                            {competitors}
                        </>
                    );



                }
            }
        ]

    const columns = useMemo(() => tableColumns, [])

    const captionTable = <CaptionTable leftCol={<Label data="HeaderRaceFacts" />} />

    return (
        <>
            {actions &&
                < MirsTable
                    className='table-result table-race-facts'
                    data={actions}
                    columns={columns}
                    id={`mirs-table-race-facts-${mirs_rsc}`}
                    caption={captionTable}
                />
            }
        </>
    )



};
export default TriRaceFacts;